const VISITOR_CORRELATION_ID_KEY = 'GBPE_VISITOR_CORRELATION_ID'

function generateUuidFromRandomValues(getRandomByte: () => number): string {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
		const random = getRandomByte()
		const value = char === 'x' ? random & 15 : (random & 3) | 8
		return value.toString(16)
	})
}

function generateUuid(): string {
	const webCrypto = globalThis.crypto
	if (typeof webCrypto?.randomUUID === 'function') {
		return webCrypto.randomUUID()
	}

	if (typeof webCrypto?.getRandomValues === 'function') {
		return generateUuidFromRandomValues(() => webCrypto.getRandomValues(new Uint8Array(1))[0])
	}

	return generateUuidFromRandomValues(() => Math.floor(Math.random() * 256))
}

export function getOrCreateVisitorCorrelationId(): string {
	const existing = sessionStorage.getItem(VISITOR_CORRELATION_ID_KEY)
	if (existing) {
		return existing
	}

	const correlationId = generateUuid()
	sessionStorage.setItem(VISITOR_CORRELATION_ID_KEY, correlationId)
	return correlationId
}
